import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiRequest from '../../api/request';
import { formatDataForDataTable } from '../../utils/formatData';
import chatApi from '../../views/chatSystem/ChatApi';

const initialState = {
  loading: false,
  notifications: [],
  allNotifications: {},
  notificationStatus: [],
  chatNotifications: [],
  totalChatCount: 0,
};

export const getAllNotifications = createAsyncThunk('socketNotification/getAllNotifications', async (data) => {
  const res = await apiRequest({
    method: 'get',
    url: `notifications?page=${data.page}&limit=${data.limit}&search=${
      data.search ? encodeURIComponent(data.search) : ''
    }`,
  });
  return res;
});
export const makeAsReadyNotifications = createAsyncThunk(
  'socketNotification/makeAsReadyNotifications',
  async (data) => {
    const res = await apiRequest({
      method: 'patch',
      url: `notifications/read-notification`,
      data: data,
    });
    return res;
  },
);
export const getNotificationStatus = createAsyncThunk('socketNotification/getNotificationStatus', async () => {
  const res = await apiRequest({
    method: 'get',
    url: `general/notification/config`,
  });
  return res;
});

export const updateStatus = createAsyncThunk('socketNotification/updateStatus', async (data) => {
  const res = await apiRequest({
    method: 'post',
    url: `general/notification/config`,
    data: data,
  });
  return res;
});

// ------------------------fetchChatUnreadCount------------------------
export const fetchChatUnreadCount = createAsyncThunk('socketNotification/fetchUnreadCount', async () => {
  const data = await chatApi.getChatListApiTrigger();
  return data.reduce((sum, chat) => sum + chat.unread_count, 0);
});
const socketNotificationSlice = createSlice({
  name: 'socketNotification',
  initialState,
  reducers: {
    // addNotification: (state, action) => {
    //   return {
    //     ...state,
    //     notifications: [action.payload.message],
    //   };
    //   // state.notifications.push(action.payload);
    // },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    addChatNotification: (state, action) => {
      state.chatNotifications.unshift(action.payload);
      state.totalChatCount += 1;
    },
    addTotalChatCount: (state, action) => {
      state.totalChatCount = action.payload;
    },
    resetChatCount: (state) => {
      state.totalChatCount = 0;
    },

    clearChatNotifications: (state) => {
      state.chatNotifications = [];
    },
    removeChatNotificationIfOpened: (state, action) => {
      state.chatNotifications = state.chatNotifications.filter((n) => n.chat_room_id !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllNotifications.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getAllNotifications.fulfilled, (state, action) => {
      const data = action.payload;
      return {
        ...state,
        allNotifications: data,
        loading: false,
      };
    });
    // ----------------makeAsReadyNotifications-------------------
    builder.addCase(makeAsReadyNotifications.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(makeAsReadyNotifications.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    // -------------------getNotificationStatus----------------------------
    builder.addCase(getNotificationStatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(getNotificationStatus.fulfilled, (state, action) => {
      const data = action.payload.data.configs;
      return {
        ...state,
        notificationStatus: data,
        loading: false,
      };
    });
    // ------------------------updateStatus------------------------
    builder.addCase(updateStatus.pending, (state, action) => {
      return {
        ...state,
        loading: true,
      };
    });
    builder.addCase(updateStatus.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
      };
    });
    //CHAT NOTIFICATION COUNT
    builder.addCase(fetchChatUnreadCount.fulfilled, (state, action) => {
      state.totalChatCount = action.payload;
    });
  },
});

export const {
  // addNotification,
  clearNotifications,
  addChatNotification,
  clearChatNotifications,
  removeChatNotificationIfOpened,
  addTotalChatCount,
  resetChatCount,
} = socketNotificationSlice.actions;

export default socketNotificationSlice.reducer;
